const JOB_STATUSES = {
  FAILED: 'failed',
  QUEUED: 'queued',
  EXECUTING: 'executing',
  FINISHED: 'finished',
};

export default JOB_STATUSES;
